import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VCard,[_c(VCardTitle,{staticClass:"primary white--text py-2"},[_vm._v("Anmeldung bestätigen")]),_c(VCardText,{staticClass:"pt-4 text-center"},[(_vm.loading)?_c(VProgressCircular,{attrs:{"indeterminate":"","color":"primary"}}):(_vm.error)?_c('div',{staticClass:"text-subtitle-2 error--text"},[_vm._v(_vm._s(_vm.error))]):_c('div',{staticClass:"text-subtitle-2"},[_vm._v(" Danke! Die Anmeldung für euer Team "),_c('strong',[_vm._v(_vm._s(_vm.teamname))]),_vm._v(" wurde bestätigt. ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }